const SUPPORTED_APP_PROVIDER_OPTIONS = {
  defaultStartShellSidePanelOpen: true,
  defaultEndShellSidePanelOpen: true,
  defaultStartContentPanelOpen: true,
  defaultEndContentPanelOpen: true
};
const APP_PROVIDER_OPTION_KEYS = Object.keys(SUPPORTED_APP_PROVIDER_OPTIONS);
export function getAppProviderOptions(config) {
  if (config.type !== 'application' || !config.appProviderOptions) {
    return {};
  }
  const {
    appProviderOptions
  } = config;
  return Object.fromEntries(APP_PROVIDER_OPTION_KEYS.filter(key => appProviderOptions[key] !== undefined).map(key => [key, appProviderOptions[key]]));
}